import dayjs from 'dayjs';
import { util } from '@/api/util/index';
export class ContactImplRecent {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async getRecentContactList(params, noCache) {
        try {
            if (!noCache) {
                const dbContactList = await this.ctx.contactDB.getRecentContact(params);
                if (dbContactList && dbContactList.length > 0) {
                    return dbContactList || [];
                }
            }
            const promise = this.ctx.contactServer.getRecentContactListInServer(params);
            return promise;
        }
        catch (e) {
            console.warn('[contact] recent contact', e);
            return Promise.resolve([]);
        }
    }
    async addRecentContact(params) {
        const additionalParam = params._account ? this.ctx.contactUtil.getAccountSession(params._account) : undefined;
        const url = this.ctx.http.buildUrl(this.ctx.systemApi.getUrl('addRecentContact'), Object.assign({}, additionalParam));
        try {
            await Promise.all(Object.values(params.memberParams)
                .filter(item => item && item.contactlist.length)
                .map(singleParam => {
                const emailList = singleParam.contactlist.map(item => item.email).join(',');
                return this.ctx.http.post(url, Object.assign({ emailList }, singleParam), {
                    _account: params._account,
                });
            }));
            const res = await this.getRecentContactList({
                page: 1,
                pageSize: 30,
                conditionType: 1,
                contactType: 1,
                _account: params._account,
            }, true);
            this.ctx.eventApi.sendSysEvent({
                eventName: 'recentContactNotify',
                eventStrData: 'notify',
                eventData: {
                    result: res,
                },
                _account: params._account,
            });
        }
        catch (e) {
            console.error('[contact] addRecentContact error', e);
        }
        const totalcontactlist = Object.values(params.memberParams).flatMap(item => item.contactlist);
        this.addFrequentContact({
            list: totalcontactlist,
            type: 'mail',
            _account: params._account,
        });
        return false;
    }
    async addFrequentContact(params) {
        var _a, _b;
        const timestamp = dayjs().startOf('hour').valueOf();
        const { list, type = 'mail' } = params;
        const newFrequentlist = list.map(item => ({
            id: util.getUnique(item.contactId, type),
            type: 'enterprise',
            contactId: item.contactId,
            email: item.email,
            timestamp,
            channel: type,
            sendcount: 1,
        }));
        const oldFrequentlist = await this.ctx.contactDB.queryFrequentContact({
            list: newFrequentlist.map(item => [item.contactId, type]),
            _account: params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
        });
        const oldFrequentMap = new Map(oldFrequentlist.map(item => [item.id, item.sendcount]));
        this.ctx.contactDB.putFrequentContact({
            list: newFrequentlist.map(item => (Object.assign(Object.assign({}, item), { sendcount: (oldFrequentMap.get(item.id) || 0) + 1 }))),
            _account: params._account || ((_b = this.ctx.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || '',
        });
    }
    getMaillistMember(accountName) {
        return this.ctx.contactServer.getMaillistMember(accountName);
    }
    async createMaillist(params) {
        const data = await this.ctx.contactServer.createMaillist(params);
        if (data.success) {
            await this.ctx.contactServer.operateMailLsit({
                action: 'ADD',
                accountName: params.account_name,
                domain: params.domain,
            });
        }
        return data;
    }
    async updateMaillist(params) {
        const data = await this.ctx.contactServer.updateMaillist(params);
        if (data.success) {
            await this.ctx.contactServer.operateMailLsit({
                action: 'UPDATE',
                accountName: params.account_name,
                domain: params.domain,
                qiyeAccountId: params.id,
            });
        }
        return data;
    }
    async deleteMaillist(params) {
        const data = await this.ctx.contactServer.deleteMaillist(params);
        if (data.success) {
            await this.ctx.contactServer.operateMailLsit({
                action: 'DELETE',
                accountName: params.account_name,
                domain: params.domain,
                qiyeAccountId: params.id,
            });
        }
        return data;
    }
    listUserDomain() {
        return this.ctx.contactServer.listUserDomain();
    }
    listUserMaillist(type) {
        return this.ctx.contactServer.listUserMaillist(type);
    }
    getMaillist(getMailListParams) {
        return this.ctx.contactServer.getMaillist(getMailListParams);
    }
    getMaillistConfig() {
        return this.ctx.contactServer.getMaillistConfig();
    }
    checkMaillistAccountName(mailListMember) {
        return this.ctx.contactServer.checkMaillistAccountName(mailListMember);
    }
}
